import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Globe2, Star } from "lucide-react";
import api from "../lib/api";
import { PageHeader, Spinner, vibrantTheme } from "../components/common";
import { AirlineCard } from "../components/PopularAirlines";

export default function GlobalAirlineRanking() {
  const [data, setData] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/airlines-popular/global-ranking").then((r) => setData(r.data)).catch(() => setData(false));
  }, []);

  const theme = vibrantTheme("global-airline-ranking");

  return (
    <div data-testid="global-airline-ranking-page">
      <PageHeader eyebrow="Global Ranking" title="Global Major Airlines"
        subtitle="One blended worldwide ranking — passenger traffic, network size, international reach and market presence (IATA World Air Transport Statistics)." />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pb-14">
        <Link to="/airlines" data-testid="back-to-airlines-link"
          className="inline-flex items-center gap-1.5 text-sm font-700 text-primary hover:underline mb-5">
          <Globe2 className="w-4 h-4" /> Back to Popular Airlines
        </Link>
        {data === null ? <Spinner /> : data === false ? <p className="text-muted-foreground py-10">Could not load the ranking.</p> : (
          <>
            <h2 className="font-heading font-900 text-2xl mb-1 flex items-center gap-2">
              <Star className="w-6 h-6 fill-amber-500 text-amber-500" /> Featured Top 20
            </h2>
            <p className="text-base text-zinc-600 mb-4">The airlines every traveller should know first.</p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 mb-10">
              {data.items.filter((a) => a.featured).map((a) => <AirlineCard key={a.iata} a={a} accent={theme.bg} />)}
            </div>
            <h2 className="font-heading font-900 text-2xl mb-4">Ranks 21–{data.items.length}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
              {data.items.filter((a) => !a.featured).map((a) => <AirlineCard key={a.iata} a={a} accent={theme.bg} />)}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
